var _g, _circle, _rect, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTip2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M22.2556 84.0055H21.2817L20.2266 68.7583H23.3108L22.2556 84.0055Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M20.7135 68.7583H20.2266L21.2817 84.0055H21.3628L20.7135 68.7583Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M22.8231 68.7583L22.1738 84.0055H22.255L23.3101 68.7583H22.8231Z",
    fill: "#FEF9E1"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M23.2296 69.3472L23.3108 68.9546H20.2266V69.3472H23.2296Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M23.3919 69.2163H20.1453L19.9019 65.748H23.5542L23.3919 69.2163Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M20.7945 69.2163H20.1458L19.9023 65.748H20.551L20.7945 69.2163Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M22.7421 69.2163H23.3908L23.6343 65.748H22.9856L22.7421 69.2163Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M23.4727 65.9771L23.5538 65.4536H19.8203V65.9771H23.4727Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M23.7977 65.9442H19.7396L19.4961 59.4004H23.9601L23.7977 65.9442Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M20.5509 65.9442H19.7396L19.4961 59.4004H20.3074L20.5509 65.9442Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M22.9052 65.9442H23.7165L23.96 59.4004H23.1486L22.9052 65.9442Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M23.9601 60.2511L24.0412 59.5967H19.4961V60.2511H23.9601Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M24.2033 59.2695H19.3335V60.0548H24.2033V59.2695Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5509 65.4537L20.064 59.6562H20.5509V65.4537Z",
    fill: "#EDE3B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9858 65.4537V59.6562H23.4728L22.9858 65.4537Z",
    fill: "#EDE3B6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M23.6194 66.0332H19.918L19.967 66.4197H23.5707L23.6194 66.0332Z",
    fill: "#CCB450"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M23.2782 69.3184H20.3076L20.3567 69.7049H23.2295L23.2782 69.3184Z",
    fill: "#CCB450"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M31.5081 84.0055H30.5341L29.479 68.7583H32.5632L31.5081 84.0055Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M29.966 68.7583H29.479L30.5341 84.0055H30.6153L29.966 68.7583Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M32.0756 68.7583L31.4263 84.0055H31.5074L32.5626 68.7583H32.0756Z",
    fill: "#FEF9E1"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M32.482 69.3472L32.5632 68.9546H29.479V69.3472H32.482Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M32.6443 69.2163H29.3978L29.1543 65.748H32.8066L32.6443 69.2163Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M30.0469 69.2163H29.3983L29.1548 65.748H29.8035L30.0469 69.2163Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M31.9946 69.2163H32.6432L32.8867 65.748H32.238L31.9946 69.2163Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M32.7251 65.9771L32.8063 65.4536H29.0728V65.9771H32.7251Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M33.0502 65.9442H28.992L28.7485 59.4004H33.2125L33.0502 65.9442Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M29.8033 65.9442H28.992L28.7485 59.4004H29.5598L29.8033 65.9442Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M32.1576 65.9442H32.9689L33.2124 59.4004H32.4011L32.1576 65.9442Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M33.2125 60.2511L33.2937 59.5967H28.7485V60.2511H33.2125Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M33.4557 59.2695H28.5859V60.0548H33.4557V59.2695Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8034 65.4537L29.3164 59.6562H29.8034V65.4537Z",
    fill: "#EDE3B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2383 65.4537V59.6562H32.7253L32.2383 65.4537Z",
    fill: "#EDE3B6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M32.8718 66.0332H29.1704L29.2195 66.4197H32.8231L32.8718 66.0332Z",
    fill: "#CCB450"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M32.5306 69.3184H29.5601L29.6091 69.7049H32.4819L32.5306 69.3184Z",
    fill: "#CCB450"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M42.5403 84.0055H41.5664L40.5112 68.7583H43.5954L42.5403 84.0055Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M40.9982 68.7583H40.5112L41.5664 84.0055H41.6475L40.9982 68.7583Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M43.1078 68.7583L42.4585 84.0055H42.5397L43.5948 68.7583H43.1078Z",
    fill: "#FEF9E1"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M43.5143 69.3472L43.5954 68.9546H40.5112V69.3472H43.5143Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M43.6765 69.2163H40.43L40.1865 65.748H43.8389L43.6765 69.2163Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M41.0792 69.2163H40.4305L40.187 65.748H40.8357L41.0792 69.2163Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M43.0268 69.2163H43.6755L43.9189 65.748H43.2703L43.0268 69.2163Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M43.7573 65.9771L43.8385 65.4536H40.105V65.9771H43.7573Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M44.0824 65.9442H40.0243L39.7808 59.4004H44.2447L44.0824 65.9442Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M40.8356 65.9442H40.0243L39.7808 59.4004H40.5921L40.8356 65.9442Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M43.1898 65.9442H44.0011L44.2446 59.4004H43.4333L43.1898 65.9442Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M44.2447 60.2511L44.3259 59.5967H39.7808V60.2511H44.2447Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M44.488 59.2695H39.6182V60.0548H44.488V59.2695Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8356 65.4537L40.3486 59.6562H40.8356V65.4537Z",
    fill: "#EDE3B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2705 65.4537V59.6562H43.7575L43.2705 65.4537Z",
    fill: "#EDE3B6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M43.9041 66.0332H40.2026L40.2517 66.4197H43.8554L43.9041 66.0332Z",
    fill: "#CCB450"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M43.5629 69.3184H40.5923L40.6414 69.7049H43.5142L43.5629 69.3184Z",
    fill: "#CCB450"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M57.6458 84.0055H56.6718L55.6167 68.7583H58.7009L57.6458 84.0055Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M56.1037 68.7583H55.6167L56.6718 84.0055H56.753L56.1037 68.7583Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M58.2133 68.7583L57.564 84.0055H57.6451L58.7003 68.7583H58.2133Z",
    fill: "#FEF9E1"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M58.6197 69.3472L58.7009 68.9546H55.6167V69.3472H58.6197Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M58.782 69.2163H55.5355L55.292 65.748H58.9443L58.782 69.2163Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M56.1846 69.2163H55.536L55.2925 65.748H55.9412L56.1846 69.2163Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M58.1323 69.2163H58.7809L59.0244 65.748H58.3757L58.1323 69.2163Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M58.8628 65.9771L58.944 65.4536H55.2104V65.9771H58.8628Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M59.1879 65.9442H55.1297L54.8862 59.4004H59.3502L59.1879 65.9442Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M55.941 65.9442H55.1297L54.8862 59.4004H55.6975L55.941 65.9442Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M58.2953 65.9442H59.1066L59.3501 59.4004H58.5388L58.2953 65.9442Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M59.3502 60.2511L59.4314 59.5967H54.8862V60.2511H59.3502Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M59.5934 59.2695H54.7236V60.0548H59.5934V59.2695Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9411 65.4537L55.4541 59.6562H55.9411V65.4537Z",
    fill: "#EDE3B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.376 65.4537V59.6562H58.863L58.376 65.4537Z",
    fill: "#EDE3B6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M59.0095 66.0332H55.3081L55.3572 66.4197H58.9608L59.0095 66.0332Z",
    fill: "#CCB450"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M58.6683 69.3184H55.6978L55.7468 69.7049H58.6196L58.6683 69.3184Z",
    fill: "#CCB450"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M67.5447 84.0055H66.5707L65.5156 68.7583H68.5998L67.5447 84.0055Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M66.0026 68.7583H65.5156L66.5707 84.0055H66.6519L66.0026 68.7583Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M68.1122 68.7583L67.4629 84.0055H67.5441L68.5992 68.7583H68.1122Z",
    fill: "#FEF9E1"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M68.5187 69.3472L68.5998 68.9546H65.5156V69.3472H68.5187Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M68.6809 69.2163H65.4344L65.1909 65.748H68.8433L68.6809 69.2163Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M66.0836 69.2163H65.4349L65.1914 65.748H65.8401L66.0836 69.2163Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M68.0312 69.2163H68.6798L68.9233 65.748H68.2747L68.0312 69.2163Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M68.7617 65.9771L68.8429 65.4536H65.1094V65.9771H68.7617Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M69.0868 65.9442H65.0286L64.7852 59.4004H69.2491L69.0868 65.9442Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M65.84 65.9442H65.0286L64.7852 59.4004H65.5965L65.84 65.9442Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M68.1942 65.9442H69.0055L69.249 59.4004H68.4377L68.1942 65.9442Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M69.2491 60.2511L69.3303 59.5967H64.7852V60.2511H69.2491Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M69.4924 59.2695H64.6226V60.0548H69.4924V59.2695Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.84 65.4537L65.353 59.6562H65.84V65.4537Z",
    fill: "#EDE3B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.2749 65.4537V59.6562H68.7619L68.2749 65.4537Z",
    fill: "#EDE3B6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M68.9085 66.0332H65.207L65.2561 66.4197H68.8598L68.9085 66.0332Z",
    fill: "#CCB450"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M68.5673 69.3184H65.5967L65.6458 69.7049H68.5186L68.5673 69.3184Z",
    fill: "#CCB450"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M77.9304 84.0055H76.9565L75.9014 68.7583H78.9856L77.9304 84.0055Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M76.3883 68.7583H75.9014L76.9565 84.0055H77.0376L76.3883 68.7583Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M78.4979 68.7583L77.8486 84.0055H77.9298L78.9849 68.7583H78.4979Z",
    fill: "#FEF9E1"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M78.9044 69.3472L78.9856 68.9546H75.9014V69.3472H78.9044Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M79.0667 69.2163H75.8201L75.5767 65.748H79.229L79.0667 69.2163Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M76.4693 69.2163H75.8206L75.5771 65.748H76.2258L76.4693 69.2163Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M78.4169 69.2163H79.0656L79.3091 65.748H78.6604L78.4169 69.2163Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M79.1475 65.9771L79.2286 65.4536H75.4951V65.9771H79.1475Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M79.4725 65.9442H75.4144L75.1709 59.4004H79.6349L79.4725 65.9442Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M76.2257 65.9442H75.4144L75.1709 59.4004H75.9822L76.2257 65.9442Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M78.58 65.9442H79.3913L79.6348 59.4004H78.8235L78.58 65.9442Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M79.6349 60.2511L79.716 59.5967H75.1709V60.2511H79.6349Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M79.8781 59.2695H75.0083V60.0548H79.8781V59.2695Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.2257 65.4537L75.7388 59.6562H76.2257V65.4537Z",
    fill: "#EDE3B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.6606 65.4537V59.6562H79.1476L78.6606 65.4537Z",
    fill: "#EDE3B6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M79.2942 66.0332H75.5928L75.6419 66.4197H79.2455L79.2942 66.0332Z",
    fill: "#CCB450"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M78.953 69.3184H75.9824L76.0315 69.7049H78.9043L78.953 69.3184Z",
    fill: "#CCB450"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter7_d)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M25.1245 84.005H24.3276L23.4644 69.4956H25.9878L25.1245 84.005Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M23.8628 69.4956H23.4644L24.3276 84.005H24.394L23.8628 69.4956Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M25.5889 69.4956L25.0576 84.005H25.124L25.9873 69.4956H25.5889Z",
    fill: "#FEF9E1"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M25.9214 70.0562L25.9878 69.6826H23.4644V70.0562H25.9214Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M26.0542 69.9318H23.3979L23.1987 66.6313H26.187L26.0542 69.9318Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M23.9287 69.9318H23.3979L23.1987 66.6313H23.7295L23.9287 69.9318Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M25.5225 69.9318H26.0532L26.2524 66.6313H25.7217L25.5225 69.9318Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M26.1201 66.8492L26.1865 66.3511H23.1318V66.8492H26.1201Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M26.3862 66.818H23.0659L22.8667 60.5908H26.519L26.3862 66.818Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M23.7297 66.818H23.0659L22.8667 60.5908H23.5305L23.7297 66.818Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M25.6555 66.818H26.3193L26.5186 60.5908H25.8548L25.6555 66.818Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M26.519 61.4005L26.5854 60.7778H22.8667V61.4005H26.519Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M26.7178 60.4663H22.7334V61.2136H26.7178V60.4663Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7295 66.3509L23.3311 60.834H23.7295V66.3509Z",
    fill: "#EDE3B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7217 66.3509V60.834H26.1201L25.7217 66.3509Z",
    fill: "#EDE3B6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M26.2399 66.9028H23.2114L23.2516 67.2706H26.2L26.2399 66.9028Z",
    fill: "#CCB450"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M25.9607 70.0288H23.5303L23.5704 70.3966H25.9209L25.9607 70.0288Z",
    fill: "#CCB450"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter8_d)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M34.395 84.005H33.5981L32.7349 69.4956H35.2583L34.395 84.005Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M33.1333 69.4956H32.7349L33.5981 84.005H33.6645L33.1333 69.4956Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M34.8594 69.4956L34.3281 84.005H34.3945L35.2578 69.4956H34.8594Z",
    fill: "#FEF9E1"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M35.1919 70.0562L35.2583 69.6826H32.7349V70.0562H35.1919Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M35.3247 69.9318H32.6685L32.4692 66.6313H35.4575L35.3247 69.9318Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M33.1992 69.9318H32.6685L32.4692 66.6313H33L33.1992 69.9318Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M34.793 69.9318H35.3237L35.5229 66.6313H34.9922L34.793 69.9318Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M35.3906 66.8492L35.457 66.3511H32.4023V66.8492H35.3906Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M35.6567 66.818H32.3364L32.1372 60.5908H35.7895L35.6567 66.818Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M33.0002 66.818H32.3364L32.1372 60.5908H32.801L33.0002 66.818Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M34.926 66.818H35.5898L35.7891 60.5908H35.1253L34.926 66.818Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M35.7895 61.4005L35.856 60.7778H32.1372V61.4005H35.7895Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M35.9883 60.4663H32.0039V61.2136H35.9883V60.4663Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 66.3509L32.6016 60.834H33V66.3509Z",
    fill: "#EDE3B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9922 66.3509V60.834H35.3906L34.9922 66.3509Z",
    fill: "#EDE3B6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M35.5104 66.9028H32.4819L32.5221 67.2706H35.4705L35.5104 66.9028Z",
    fill: "#CCB450"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M35.2312 70.0288H32.8008L32.8409 70.3966H35.1914L35.2312 70.0288Z",
    fill: "#CCB450"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter9_d)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M45.894 84.005H45.0972L44.2339 69.4956H46.7573L45.894 84.005Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M44.6323 69.4956H44.2339L45.0972 84.005H45.1636L44.6323 69.4956Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M46.3584 69.4956L45.8271 84.005H45.8936L46.7568 69.4956H46.3584Z",
    fill: "#FEF9E1"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M46.6909 70.0562L46.7573 69.6826H44.2339V70.0562H46.6909Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M46.8237 69.9318H44.1675L43.9683 66.6313H46.9565L46.8237 69.9318Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M44.6982 69.9318H44.1675L43.9683 66.6313H44.499L44.6982 69.9318Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M46.292 69.9318H46.8228L47.022 66.6313H46.4912L46.292 69.9318Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M46.8896 66.8492L46.9561 66.3511H43.9014V66.8492H46.8896Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M47.1558 66.818H43.8354L43.6362 60.5908H47.2886L47.1558 66.818Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M44.4993 66.818H43.8354L43.6362 60.5908H44.3L44.4993 66.818Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M46.4251 66.818H47.0889L47.2881 60.5908H46.6243L46.4251 66.818Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M47.2886 61.4005L47.355 60.7778H43.6362V61.4005H47.2886Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M47.4873 60.4663H43.5029V61.2136H47.4873V60.4663Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.499 66.3509L44.1006 60.834H44.499V66.3509Z",
    fill: "#EDE3B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4912 66.3509V60.834H46.8896L46.4912 66.3509Z",
    fill: "#EDE3B6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M47.0094 66.9028H43.981L44.0211 67.2706H46.9695L47.0094 66.9028Z",
    fill: "#CCB450"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M46.7303 70.0288H44.2998L44.34 70.3966H46.6904L46.7303 70.0288Z",
    fill: "#CCB450"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter10_d)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M54.4404 84.005H53.6436L52.7803 69.4956H55.3037L54.4404 84.005Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M53.1787 69.4956H52.7803L53.6436 84.005H53.71L53.1787 69.4956Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M54.9048 69.4956L54.3735 84.005H54.4399L55.3032 69.4956H54.9048Z",
    fill: "#FEF9E1"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M55.2373 70.0562L55.3037 69.6826H52.7803V70.0562H55.2373Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M55.3701 69.9318H52.7139L52.5146 66.6313H55.5029L55.3701 69.9318Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M53.2446 69.9318H52.7139L52.5146 66.6313H53.0454L53.2446 69.9318Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M54.8384 69.9318H55.3691L55.5684 66.6313H55.0376L54.8384 69.9318Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M55.436 66.8492L55.5024 66.3511H52.4478V66.8492H55.436Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M55.7021 66.818H52.3818L52.1826 60.5908H55.835L55.7021 66.818Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M53.0456 66.818H52.3818L52.1826 60.5908H52.8464L53.0456 66.818Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M54.9715 66.818H55.6353L55.8345 60.5908H55.1707L54.9715 66.818Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M55.835 61.4005L55.9014 60.7778H52.1826V61.4005H55.835Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M56.0337 60.4663H52.0493V61.2136H56.0337V60.4663Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0454 66.3509L52.647 60.834H53.0454V66.3509Z",
    fill: "#EDE3B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0376 66.3509V60.834H55.436L55.0376 66.3509Z",
    fill: "#EDE3B6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M55.5558 66.9028H52.5273L52.5675 67.2706H55.5159L55.5558 66.9028Z",
    fill: "#CCB450"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M55.2767 70.0288H52.8462L52.8863 70.3966H55.2368L55.2767 70.0288Z",
    fill: "#CCB450"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter11_d)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M64.3428 84.005H63.5459L62.6826 69.4956H65.2061L64.3428 84.005Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M63.0811 69.4956H62.6826L63.5459 84.005H63.6123L63.0811 69.4956Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M64.8071 69.4956L64.2759 84.005H64.3423L65.2056 69.4956H64.8071Z",
    fill: "#FEF9E1"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M65.1396 70.0562L65.2061 69.6826H62.6826V70.0562H65.1396Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M65.2725 69.9318H62.6162L62.417 66.6313H65.4053L65.2725 69.9318Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M63.1469 69.9318H62.6162L62.417 66.6313H62.9477L63.1469 69.9318Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M64.7408 69.9318H65.2715L65.4707 66.6313H64.94L64.7408 69.9318Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M65.3384 66.8492L65.4048 66.3511H62.3501V66.8492H65.3384Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M65.6045 66.818H62.2842L62.085 60.5908H65.7373L65.6045 66.818Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M62.948 66.818H62.2842L62.085 60.5908H62.7488L62.948 66.818Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M64.8738 66.818H65.5376L65.7368 60.5908H65.073L64.8738 66.818Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M65.7373 61.4005L65.8037 60.7778H62.085V61.4005H65.7373Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M65.936 60.4663H61.9517V61.2136H65.936V60.4663Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9478 66.3509L62.5493 60.834H62.9478V66.3509Z",
    fill: "#EDE3B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9399 66.3509V60.834H65.3384L64.9399 66.3509Z",
    fill: "#EDE3B6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M65.4581 66.9028H62.4297L62.4698 67.2706H65.4183L65.4581 66.9028Z",
    fill: "#CCB450"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M65.179 70.0288H62.7485L62.7887 70.3966H65.1392L65.179 70.0288Z",
    fill: "#CCB450"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter12_d)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M74.438 84.005H73.6411L72.7778 69.4956H75.3013L74.438 84.005Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M73.1763 69.4956H72.7778L73.6411 84.005H73.7075L73.1763 69.4956Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M74.9023 69.4956L74.3711 84.005H74.4375L75.3008 69.4956H74.9023Z",
    fill: "#FEF9E1"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M75.2349 70.0562L75.3013 69.6826H72.7778V70.0562H75.2349Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M75.3677 69.9318H72.7114L72.5122 66.6313H75.5005L75.3677 69.9318Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M73.2422 69.9318H72.7114L72.5122 66.6313H73.0429L73.2422 69.9318Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M74.836 69.9318H75.3667L75.5659 66.6313H75.0352L74.836 69.9318Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M75.4336 66.8492L75.5 66.3511H72.4453V66.8492H75.4336Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M75.6997 66.818H72.3794L72.1802 60.5908H75.8325L75.6997 66.818Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M73.0432 66.818H72.3794L72.1802 60.5908H72.844L73.0432 66.818Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M74.969 66.818H75.6328L75.832 60.5908H75.1682L74.969 66.818Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M75.8325 61.4005L75.8989 60.7778H72.1802V61.4005H75.8325Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M76.0312 60.4663H72.0469V61.2136H76.0312V60.4663Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.043 66.3509L72.6445 60.834H73.043V66.3509Z",
    fill: "#EDE3B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.0352 66.3509V60.834H75.4336L75.0352 66.3509Z",
    fill: "#EDE3B6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M75.5533 66.9028H72.5249L72.5651 67.2706H75.5135L75.5533 66.9028Z",
    fill: "#CCB450"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M75.2742 70.0288H72.8438L72.8839 70.3966H75.2344L75.2742 70.0288Z",
    fill: "#CCB450"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_d)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M18.2005 84.0054H17.0671L15.8394 68.0205H19.4282L18.2005 84.0054Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M16.406 68.0205H15.8394L17.0671 84.0054H17.1616L16.406 68.0205Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M18.8605 68.0205L18.105 84.0054H18.1994L19.4272 68.0205H18.8605Z",
    fill: "#FEF9E1"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M19.3338 68.6377L19.4282 68.2261H15.8394V68.6377H19.3338Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M19.523 68.5008H15.7452L15.4619 64.8647H19.7119L19.523 68.5008Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M16.5001 68.5008H15.7452L15.4619 64.8647H16.2167L16.5001 68.5008Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M18.767 68.5008H19.5218L19.8052 64.8647H19.0504L18.767 68.5008Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M19.6172 65.105L19.7116 64.5562H15.3672V65.105H19.6172Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M19.9953 65.0704H15.2731L14.9897 58.21H20.1842L19.9953 65.0704Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M16.2172 65.0704H15.2731L14.9897 58.21H15.9338L16.2172 65.0704Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M18.9562 65.0704H19.9003L20.1836 58.21H19.2395L18.9562 65.0704Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M20.1842 59.1016L20.2786 58.4155H14.9897V59.1016H20.1842Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M20.467 58.0728H14.8003V58.896H20.467V58.0728Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2171 64.556L15.6504 58.478H16.2171V64.556Z",
    fill: "#EDE3B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0503 64.556V58.478H19.617L19.0503 64.556Z",
    fill: "#EDE3B6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M19.7876 65.1636H15.4805L15.5376 65.5688H19.7309L19.7876 65.1636Z",
    fill: "#CCB450"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M19.3903 68.6079H15.9336L15.9907 69.0131H19.3336L19.3903 68.6079Z",
    fill: "#CCB450"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_d)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M28.9671 84.0054H27.8337L26.606 68.0205H30.1948L28.9671 84.0054Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M27.1726 68.0205H26.606L27.8337 84.0054H27.9282L27.1726 68.0205Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M29.6271 68.0205L28.8716 84.0054H28.966L30.1938 68.0205H29.6271Z",
    fill: "#FEF9E1"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M30.1004 68.6377L30.1948 68.2261H26.606V68.6377H30.1004Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M30.2896 68.5008H26.5118L26.2285 64.8647H30.4785L30.2896 68.5008Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M27.2667 68.5008H26.5118L26.2285 64.8647H26.9833L27.2667 68.5008Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M29.5336 68.5008H30.2884L30.5718 64.8647H29.817L29.5336 68.5008Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M30.3838 65.105L30.4782 64.5562H26.1338V65.105H30.3838Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M30.7619 65.0704H26.0397L25.7563 58.21H30.9508L30.7619 65.0704Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M26.9838 65.0704H26.0397L25.7563 58.21H26.7004L26.9838 65.0704Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M29.7228 65.0704H30.6669L30.9502 58.21H30.0061L29.7228 65.0704Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M30.9508 59.1016L31.0452 58.4155H25.7563V59.1016H30.9508Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M31.2336 58.0728H25.5669V58.896H31.2336V58.0728Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9837 64.556L26.417 58.478H26.9837V64.556Z",
    fill: "#EDE3B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8169 64.556V58.478H30.3836L29.8169 64.556Z",
    fill: "#EDE3B6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M30.5542 65.1636H26.2471L26.3042 65.5688H30.4975L30.5542 65.1636Z",
    fill: "#CCB450"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M30.1569 68.6079H26.7002L26.7573 69.0131H30.1002L30.1569 68.6079Z",
    fill: "#CCB450"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter15_d)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M39.1673 84.0054H38.0339L36.8062 68.0205H40.395L39.1673 84.0054Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M37.3728 68.0205H36.8062L38.0339 84.0054H38.1284L37.3728 68.0205Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M39.8273 68.0205L39.0718 84.0054H39.1662L40.394 68.0205H39.8273Z",
    fill: "#FEF9E1"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M40.3006 68.6377L40.395 68.2261H36.8062V68.6377H40.3006Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M40.4898 68.5008H36.712L36.4287 64.8647H40.6787L40.4898 68.5008Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M37.4669 68.5008H36.712L36.4287 64.8647H37.1835L37.4669 68.5008Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M39.7338 68.5008H40.4886L40.772 64.8647H40.0172L39.7338 68.5008Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M40.584 65.105L40.6784 64.5562H36.334V65.105H40.584Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M40.9621 65.0704H36.2399L35.9565 58.21H41.151L40.9621 65.0704Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M37.184 65.0704H36.2399L35.9565 58.21H36.9006L37.184 65.0704Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M39.923 65.0704H40.8671L41.1504 58.21H40.2063L39.923 65.0704Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M41.151 59.1016L41.2454 58.4155H35.9565V59.1016H41.151Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M41.4338 58.0728H35.7671V58.896H41.4338V58.0728Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1839 64.556L36.6172 58.478H37.1839V64.556Z",
    fill: "#EDE3B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0171 64.556V58.478H40.5838L40.0171 64.556Z",
    fill: "#EDE3B6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M40.7544 65.1636H36.4473L36.5044 65.5688H40.6977L40.7544 65.1636Z",
    fill: "#CCB450"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M40.3571 68.6079H36.9004L36.9575 69.0131H40.3004L40.3571 68.6079Z",
    fill: "#CCB450"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter16_d)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M49.9339 84.0054H48.8005L47.5728 68.0205H51.1616L49.9339 84.0054Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M48.1394 68.0205H47.5728L48.8005 84.0054H48.895L48.1394 68.0205Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M50.5939 68.0205L49.8384 84.0054H49.9328L51.1606 68.0205H50.5939Z",
    fill: "#FEF9E1"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M51.0672 68.6377L51.1616 68.2261H47.5728V68.6377H51.0672Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M51.2564 68.5008H47.4786L47.1953 64.8647H51.4453L51.2564 68.5008Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M48.2335 68.5008H47.4786L47.1953 64.8647H47.9501L48.2335 68.5008Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M50.5004 68.5008H51.2552L51.5386 64.8647H50.7838L50.5004 68.5008Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M51.3506 65.105L51.445 64.5562H47.1006V65.105H51.3506Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M51.7287 65.0704H47.0065L46.7231 58.21H51.9176L51.7287 65.0704Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M47.9506 65.0704H47.0065L46.7231 58.21H47.6672L47.9506 65.0704Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M50.6896 65.0704H51.6337L51.917 58.21H50.9729L50.6896 65.0704Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M51.9176 59.1016L52.012 58.4155H46.7231V59.1016H51.9176Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M52.2004 58.0728H46.5337V58.896H52.2004V58.0728Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9505 64.556L47.3838 58.478H47.9505V64.556Z",
    fill: "#EDE3B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7837 64.556V58.478H51.3504L50.7837 64.556Z",
    fill: "#EDE3B6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M51.521 65.1636H47.2139L47.271 65.5688H51.4643L51.521 65.1636Z",
    fill: "#CCB450"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M51.1237 68.6079H47.667L47.7241 69.0131H51.067L51.1237 68.6079Z",
    fill: "#CCB450"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter17_d)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M60.7005 84.0054H59.5671L58.3394 68.0205H61.9282L60.7005 84.0054Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M58.906 68.0205H58.3394L59.5671 84.0054H59.6616L58.906 68.0205Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M61.3605 68.0205L60.605 84.0054H60.6994L61.9272 68.0205H61.3605Z",
    fill: "#FEF9E1"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M61.8338 68.6377L61.9282 68.2261H58.3394V68.6377H61.8338Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M62.023 68.5008H58.2452L57.9619 64.8647H62.2119L62.023 68.5008Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M59.0001 68.5008H58.2452L57.9619 64.8647H58.7167L59.0001 68.5008Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M61.267 68.5008H62.0218L62.3052 64.8647H61.5504L61.267 68.5008Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M62.1172 65.105L62.2116 64.5562H57.8672V65.105H62.1172Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M62.4953 65.0704H57.7731L57.4897 58.21H62.6842L62.4953 65.0704Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M58.7172 65.0704H57.7731L57.4897 58.21H58.4338L58.7172 65.0704Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M61.4562 65.0704H62.4003L62.6836 58.21H61.7395L61.4562 65.0704Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M62.6842 59.1016L62.7786 58.4155H57.4897V59.1016H62.6842Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M62.967 58.0728H57.3003V58.896H62.967V58.0728Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7171 64.556L58.1504 58.478H58.7171V64.556Z",
    fill: "#EDE3B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5503 64.556V58.478H62.117L61.5503 64.556Z",
    fill: "#EDE3B6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M62.2876 65.1636H57.9805L58.0376 65.5688H62.2309L62.2876 65.1636Z",
    fill: "#CCB450"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M61.8903 68.6079H58.4336L58.4907 69.0131H61.8336L61.8903 68.6079Z",
    fill: "#CCB450"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter18_d)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M70.9007 84.0054H69.7673L68.5396 68.0205H72.1284L70.9007 84.0054Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M69.1062 68.0205H68.5396L69.7673 84.0054H69.8618L69.1062 68.0205Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M71.5607 68.0205L70.8052 84.0054H70.8996L72.1274 68.0205H71.5607Z",
    fill: "#FEF9E1"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M72.034 68.6377L72.1284 68.2261H68.5396V68.6377H72.034Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M72.2232 68.5008H68.4454L68.1621 64.8647H72.4121L72.2232 68.5008Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M69.2003 68.5008H68.4454L68.1621 64.8647H68.9169L69.2003 68.5008Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M71.4672 68.5008H72.222L72.5054 64.8647H71.7506L71.4672 68.5008Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M72.3174 65.105L72.4118 64.5562H68.0674V65.105H72.3174Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M72.6955 65.0704H67.9733L67.6899 58.21H72.8844L72.6955 65.0704Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M68.9173 65.0704H67.9733L67.6899 58.21H68.634L68.9173 65.0704Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M71.6564 65.0704H72.6005L72.8838 58.21H71.9397L71.6564 65.0704Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M72.8844 59.1016L72.9788 58.4155H67.6899V59.1016H72.8844Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M73.1672 58.0728H67.5005V58.896H73.1672V58.0728Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9173 64.556L68.3506 58.478H68.9173V64.556Z",
    fill: "#EDE3B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7505 64.556V58.478H72.3172L71.7505 64.556Z",
    fill: "#EDE3B6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M72.4878 65.1636H68.1807L68.2378 65.5688H72.4311L72.4878 65.1636Z",
    fill: "#CCB450"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M72.0905 68.6079H68.6338L68.6909 69.0131H72.0338L72.0905 68.6079Z",
    fill: "#CCB450"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter19_d)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M81.6673 84.0054H80.5339L79.3062 68.0205H82.895L81.6673 84.0054Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M79.8728 68.0205H79.3062L80.5339 84.0054H80.6284L79.8728 68.0205Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M82.3273 68.0205L81.5718 84.0054H81.6662L82.894 68.0205H82.3273Z",
    fill: "#FEF9E1"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M82.8006 68.6377L82.895 68.2261H79.3062V68.6377H82.8006Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M82.9898 68.5008H79.212L78.9287 64.8647H83.1787L82.9898 68.5008Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M79.9669 68.5008H79.212L78.9287 64.8647H79.6835L79.9669 68.5008Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M82.2338 68.5008H82.9886L83.272 64.8647H82.5172L82.2338 68.5008Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M83.084 65.105L83.1784 64.5562H78.834V65.105H83.084Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M83.4621 65.0704H78.7399L78.4565 58.21H83.651L83.4621 65.0704Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M79.684 65.0704H78.7399L78.4565 58.21H79.4006L79.684 65.0704Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M82.423 65.0704H83.3671L83.6504 58.21H82.7063L82.423 65.0704Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M83.651 59.1016L83.7454 58.4155H78.4565V59.1016H83.651Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M83.9338 58.0728H78.2671V58.896H83.9338V58.0728Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6839 64.556L79.1172 58.478H79.6839V64.556Z",
    fill: "#EDE3B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5171 64.556V58.478H83.0838L82.5171 64.556Z",
    fill: "#EDE3B6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M83.2544 65.1636H78.9473L79.0044 65.5688H83.1977L83.2544 65.1636Z",
    fill: "#CCB450"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M82.8571 68.6079H79.4004L79.4575 69.0131H82.8004L82.8571 68.6079Z",
    fill: "#CCB450"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 11.9668,
    y: 64.855,
    width: 77.0667,
    height: 5.98446,
    rx: 2,
    fill: "#F79689"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9668 66.555C11.9668 65.6161 12.7279 64.855 13.6668 64.855V64.855V70.4405V70.4405C12.7279 70.4405 11.9668 69.6794 11.9668 68.7405V66.555Z",
    fill: "#D8786C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9668 68.4459C11.9668 68.0052 12.324 67.6479 12.7647 67.6479H87.9001V69.2438H12.7647C12.324 69.2438 11.9668 68.8866 11.9668 68.4459V68.4459Z",
    fill: "#D8786C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0337 68.7404C89.0337 69.6793 88.2726 70.4404 87.3337 70.4404V70.4404L87.3337 64.8549V64.8549C88.2726 64.8549 89.0337 65.6161 89.0337 66.5549L89.0337 68.7404Z",
    fill: "#D8786C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.56689 70.0417C8.56689 69.1603 9.28138 68.4458 10.1627 68.4458H10.2669V70.0417H8.56689V70.0417Z",
    fill: "#D8786C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.7334 68.4458H90.8375C91.7189 68.4458 92.4334 69.1603 92.4334 70.0417V70.0417H90.7334V68.4458Z",
    fill: "#D8786C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.56689 70.0417C8.56689 69.1603 9.28138 68.4458 10.1628 68.4458H90.8377C91.7191 68.4458 92.4336 69.1603 92.4336 70.0417V70.0417H8.56689V70.0417Z",
    fill: "#F79689"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.2146 71.3394C90.1963 71.3812 90.1775 71.4248 90.1583 71.4703C89.9097 72.0568 89.5833 72.946 89.2586 74.1779C88.6289 76.567 88.0062 80.2431 87.9689 85.5H81.7362L80.386 85.1197L80.3195 85.101H80.2504H20.1838H20.1147L20.0482 85.1197L18.698 85.5H13.0321C12.9984 80.3425 12.4455 76.6735 11.8875 74.2672C11.5996 73.0256 11.3104 72.1207 11.0907 71.5213C11.0672 71.4572 11.0445 71.3965 11.0227 71.3394H90.2146Z",
    fill: "#F5F7F9",
    fillOpacity: 0.6,
    stroke: "#E5ECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2671 70.4404C10.2671 70.4404 12.5338 74.829 12.5338 85.6011H18.7671L20.1838 85.2021H80.2504L81.6671 85.6011H88.4671C88.4671 74.6295 90.7338 70.4404 90.7338 70.4404",
    stroke: "#E5ECF0",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.56689 70.0415H92.4336V70.0415C92.4336 70.4822 92.0763 70.8394 91.6356 70.8394H9.36482C8.92414 70.8394 8.56689 70.4822 8.56689 70.0415V70.0415Z",
    fill: "#E5ECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5337 85.2023V78.4585C80.5337 76.4251 72.0337 73.2334 50.5004 73.2334C28.9671 73.2334 19.9004 76.4251 19.9004 78.4585V85.2023",
    stroke: "#E5ECF0",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 44.8335,
    y: 72.0366,
    width: 11.3333,
    height: 2.39378,
    rx: 1,
    fill: "#F5F7F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6513 53.0659L19.9503 53.4869H20.4666H80.25H80.6458L80.9344 53.216L81.4958 52.689H89.232L90.2301 67.4454H10.2032L11.2013 52.689L19.3836 52.689L19.6513 53.0659Z",
    fill: "#F5F7F9",
    fillOpacity: 0.6,
    stroke: "#E5ECF0",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8423 52.1522C20.6575 51.6318 20.0857 51.3597 19.5653 51.5445C19.0448 51.7293 18.7727 52.301 18.9575 52.8214L20.8423 52.1522ZM20.0909 56.0131C20.2757 56.5336 20.8474 56.8057 21.3679 56.6209C21.8883 56.4361 22.1604 55.8644 21.9756 55.3439L20.0909 56.0131ZM18.9575 52.8214L20.0909 56.0131L21.9756 55.3439L20.8423 52.1522L18.9575 52.8214Z",
    fill: "#E5ECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.1577 52.1522C80.3425 51.6318 80.9143 51.3597 81.4347 51.5445C81.9552 51.7293 82.2273 52.301 82.0425 52.8214L80.1577 52.1522ZM80.9091 56.0131C80.7243 56.5336 80.1526 56.8057 79.6321 56.6209C79.1117 56.4361 78.8396 55.8644 79.0244 55.3439L80.9091 56.0131ZM82.0425 52.8214L80.9091 56.0131L79.0244 55.3439L80.1577 52.1522L82.0425 52.8214Z",
    fill: "#E5ECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4331 52.8857H59.5664V54.4764C59.5664 55.581 58.671 56.4764 57.5664 56.4764H43.4331C42.3285 56.4764 41.4331 55.581 41.4331 54.4764V52.8857Z",
    stroke: "#E5ECF0",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.2666,
    y: 68.6475,
    width: 10.4667,
    height: 5.97928,
    rx: 2,
    fill: "#F5F7F9",
    fillOpacity: 0.6,
    stroke: "#E5ECF0",
    strokeWidth: 2
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 78.5,
    cy: 80.3574,
    r: 13,
    fill: "#F3F8EF",
    stroke: "#84BE60"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 72.1206,
    y: 80.9097,
    width: 6.84768,
    height: 3,
    transform: "rotate(45 72.1206 80.9097)",
    fill: "#5F9340"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 87.0688,
    y: 75.979,
    width: 17,
    height: 3,
    transform: "rotate(135 87.0688 75.979)",
    fill: "#5F9340"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 5,
    y: 8,
    width: 91,
    height: 83,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d",
    x: 16.3335,
    y: 58.2695,
    width: 10.8698,
    height: 30.7359,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d",
    x: 25.5859,
    y: 58.2695,
    width: 10.8698,
    height: 30.7359,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d",
    x: 36.6182,
    y: 58.2695,
    width: 10.8698,
    height: 30.7359,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d",
    x: 51.7236,
    y: 58.2695,
    width: 10.8698,
    height: 30.7359,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d",
    x: 61.6226,
    y: 58.2695,
    width: 10.8698,
    height: 30.7359,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d",
    x: 72.0083,
    y: 58.2695,
    width: 10.8698,
    height: 30.7359,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d",
    x: 19.7334,
    y: 59.4663,
    width: 9.98438,
    height: 29.5389,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_d",
    x: 29.0039,
    y: 59.4663,
    width: 9.98437,
    height: 29.5389,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_d",
    x: 40.5029,
    y: 59.4663,
    width: 9.98438,
    height: 29.5389,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_d",
    x: 49.0493,
    y: 59.4663,
    width: 9.98438,
    height: 29.5389,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_d",
    x: 58.9517,
    y: 59.4663,
    width: 9.98438,
    height: 29.5389,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_d",
    x: 69.0469,
    y: 59.4663,
    width: 9.98438,
    height: 29.5389,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_d",
    x: 11.8003,
    y: 57.0728,
    width: 11.6667,
    height: 31.9327,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_d",
    x: 22.5669,
    y: 57.0728,
    width: 11.6667,
    height: 31.9327,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_d",
    x: 32.7671,
    y: 57.0728,
    width: 11.6667,
    height: 31.9327,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_d",
    x: 43.5337,
    y: 57.0728,
    width: 11.6667,
    height: 31.9327,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter17_d",
    x: 54.3003,
    y: 57.0728,
    width: 11.6667,
    height: 31.9327,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter18_d",
    x: 64.5005,
    y: 57.0728,
    width: 11.6667,
    height: 31.9327,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter19_d",
    x: 75.2671,
    y: 57.0728,
    width: 11.6667,
    height: 31.9327,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 85,
    height: 77,
    fill: "white",
    transform: "translate(8 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTip2);
export default __webpack_public_path__ + "static/media/tip2.6873acf5ec58d9bf5b47b630f193271a.svg";
export { ForwardRef as ReactComponent };